import dynamic from "next/dynamic";

export const DynamicContent057 = dynamic(() => import("./Content057"), {
  suspense: true,
});
